import { atom } from "recoil";

export const CampaignUnsavedChangesAtom = atom<boolean>({
  key: "CampaignUnsavedChangesAtom",
  default: false,
});
